// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FundInvestmentSubscriptionFromJSON(json) {
    return {
        'startDate': !exists(json, 'startDate') ? undefined : new Date(json['startDate']),
        'exitDate': !exists(json, 'exitDate') ? undefined : new Date(json['exitDate']),
        'investorId': !exists(json, 'investorId') ? undefined : json['investorId'],
        'investmentId': !exists(json, 'investmentId') ? undefined : json['investmentId'],
        'investorName': !exists(json, 'investorName') ? undefined : json['investorName'],
        'investorType': !exists(json, 'investorType') ? undefined : json['investorType'],
        'investmentType': !exists(json, 'investmentType') ? undefined : json['investmentType'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'commitment': !exists(json, 'commitment') ? undefined : json['commitment'],
        'commitmentDate': !exists(json, 'commitmentDate') ? undefined : new Date(json['commitmentDate']),
        'lastInvestorCashFlowDate': !exists(json, 'lastInvestorCashFlowDate') ? undefined : new Date(json['lastInvestorCashFlowDate']),
    };
}
export function FundInvestmentSubscriptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'startDate': value.startDate === undefined ? undefined : value.startDate.toISOString(),
        'exitDate': value.exitDate === undefined ? undefined : value.exitDate.toISOString(),
        'investorId': value.investorId,
        'investmentId': value.investmentId,
        'investorName': value.investorName,
        'investorType': value.investorType,
        'investmentType': value.investmentType,
        'currency': value.currency,
        'commitment': value.commitment,
        'commitmentDate': value.commitmentDate === undefined ? undefined : value.commitmentDate.toISOString(),
        'lastInvestorCashFlowDate': value.lastInvestorCashFlowDate === undefined ? undefined : value.lastInvestorCashFlowDate.toISOString(),
    };
}
